import Act from "./Act";
import Model from "./Model";
import Media from './Media';
import Tooth from './Tooth';
import Patient from "./Patient";
import Practitioner from "./Practitioner";
import TreatmentSession from './TreatmentSession';
import { ClassTransformOptions, plainToClass, Type } from "class-transformer";

class Treatment extends Model {
    id: number;
    act_id: number;
    patient_id: number;
    peactitioner_id: number;
    establishment_id: number;
    invoice_id: number;
    name: string;
    status: string;
    fees: number;
    date: string;
    comment: string;
    @Type(() => Date)
    created_at: Date;
    @Type(() => Date)
    updated_at: Date;

    /*
    |--------------------------------------------------------------------------
    | Reflection
    |--------------------------------------------------------------------------
    */

    /**
     * Gets class name
     * survives minification/uglification
     *
     * @return {string}
     */
    getClassName(): string {
        return 'Treatment';
    }

    /*
    |--------------------------------------------------------------------------
    | Relationships
    |--------------------------------------------------------------------------
    */

    @Type(() => Practitioner)
    practitioner: Practitioner;

    @Type(() => Patient)
    patient: Patient;

    @Type(() => Act)
    act: Act;

    @Type(() => TreatmentSession)
    sessions: TreatmentSession[];

    @Type(() => Media)
    documents: Media[];

    @Type(() => Tooth)
    teeth: Tooth[];

    /*
    |--------------------------------------------------------------------------
    | Methods
    |--------------------------------------------------------------------------
    */

    /**
     * Calculate fees left over.
     *
     * @returns {number}
     */
    left(): number {
        return Number(this.fees) - this.payments();
    }

    /**
     * Treatment payments.
     *
     * @returns {number}
     */
    payments(): number {
        return this.sessions.reduce((total, session) => {
            return total + Number(session.payment);
        },  0);
    }

    /**
     * Get formated date.
     *
     * @returns {string}
     */
    getDate(format = "YYYY-MM-DD"): string {
        return window.moment(this.date).format(format);
    }

    /**
     * Check if treatment is unbilled.
     *
     * @returns {boolean}
     */
    isUnbilled(): boolean {
        return !this.isBilled();
    }

    /**
     * Check if treatment is billed.
     *
     * @returns {boolean}
     */
    isBilled(): boolean {
        return !!this.invoice_id;
    }

    /**
     * Converts plain (literal) object to class (constructor) object. Also works with arrays.
     */
    static new(plain: [], options?: ClassTransformOptions): Treatment[];
    static new(plain: {}, options?: ClassTransformOptions): Treatment;
    static new(plain: {} | [], options?: ClassTransformOptions): Treatment | Treatment[] {
        return plainToClass(Treatment, plain as any, options);
    }

}

export default Treatment;
